import {eventLogsActionTypes} from './../constants/ActionTypes';

const initialState = {
  eventLogs: null,
  pagination: null,
  isRequestPending: false
};

const eventLogs = (state = initialState, action) => {
  switch (action.type) {
    case eventLogsActionTypes.GET_EVENT_LOGS:
      return {
        ...state,
        eventLogs: action.eventLogs,
        pagination: action.pagination
      };
    case eventLogsActionTypes.SET_IS_REQUEST_PENDING:
      return {
        ...state,
        isRequestPending: action.isRequestPending
      };
  }

  return state;
};

export default eventLogs;



// WEBPACK FOOTER //
// ./reducers/eventLogs.reducers.js